<template>
  <div id="ag-grid-demo">
    <vx-card>
      <data-table
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        :row-data="reportdata"
        :total="total"
        pagination
        :current-page="currentPage"
        :pagination-page-size="pageSize"
        :reset-current-page-flag="resetCurrentPageFlag"
        @update:reset-current-page-flag="resetCurrentPageFlag = false"
        @update:current-page="onUpdateCurrentPage"
        @update:pagination-page-size="onUpdatePaginationPageSize"
        @sort-changed="onSortChange"
      >
        <template #actions>
          <vs-button
            class="mb-4 md:mb-0 mr-4"
            @click="onCSVExportClick"
          >
            CSVエクスポート
          </vs-button>
          <DateRanges
            :start-day="startDay"
            :end-day="endDay"
            @on-change="onDateChange"
          />
        </template>
      </data-table>
    </vx-card>
  </div>
</template>

<script>
import moment from 'moment'
import DateRanges from '@/components/DateRanges'
import DataTable from '@/components/table/DataTable'
import {mapActions} from 'vuex'

export default {
  name: 'Asin',
  components: {
    DataTable,
    DateRanges
  },
  data () {
    return {
      sortParam: '',
      currentPage: 1,
      total: 0,
      pageSize: 20,
      resetCurrentPageFlag: false,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: false,
        suppressMenu: true
      },
      columnDefs: [
        { headerName: 'ASIN', field: 'asin', width: 175, pinned: 'left' },
        { headerName: '商品名', field: 'title', pinned: 'left' },
        { headerName: '親ASIN', field: 'parentAsin' },
        { headerName: '出品者カテゴリー1', field: 'sellerCategory' },
        { headerName: '出品者カテゴリー2', field: 'sellerCategory2' },
        { headerName: '出品者カテゴリー3', field: 'sellerCategory3' },
        { headerName: '出品者カテゴリー4', field: 'sellerCategory4' },
        { headerName: '出品者カテゴリー5', field: 'sellerCategory5' },
        { headerName: 'カテゴリー名', field: 'categoryName'},
        { headerName: 'サブカテゴリー名', field: 'subcategoryName' },
        { headerName: 'ブランド', field: 'brand' },
        { headerName: '商品売上', field: 'sales' },
        { headerName: '平均売価', field: 'averageSales' },
        { headerName: '発送済み商品数', field: 'quantityShipped' },
        { headerName: '注文率', field: 'orderRate' },
        { headerName: '広告費', field: 'adCost' },
        { headerName: 'インプレッション数', field: 'impressions' },
        { headerName: 'クリック数', field: 'clicks' },
        { headerName: 'コンバージョン数', field: 'conversions' },
        { headerName: '広告経由売上', field: 'adSales' },
        { headerName: 'CPM', field: 'cpm' },
        { headerName: 'CTR', field: 'ctr' },
        { headerName: 'CPC', field: 'cpc' },
        { headerName: 'CVR', field: 'cvr' },
        { headerName: 'CPA', field: 'cpa' },
        { headerName: 'CV単価', field: 'spa' },
        { headerName: '広告ROAS', field: 'adRoas' },
        { headerName: '自然売上', field: 'naturalSales' },
        { headerName: 'セッション数', field: 'sessions' },
        { headerName: 'ページビュー数', field: 'pageviews' },
        { headerName: 'カートボックス獲得PV', field: 'cartboxPv' },
        { headerName: 'カートボックス獲得率', field: 'cartboxRate' },
        { headerName: 'Total ACOS', field: 'totalAcos' }
      ]
    }
  },
  computed: {
    reportdata: {
      get () {
        return this.$store.getters['salesReport/asinData']
      }
    },
    startDay: {
      get () {
        return this.$store.state.startDay
      }
    },
    endDay: {
      get () {
        return this.$store.state.endDay
      }
    }
  },
  mounted () {
    this.getReport()
  },
  methods: {
    ...mapActions('salesReport', ['getAsin', 'downloadCSV']),
    async getReport () {
      const payload = {
        start_day: this.startDay.split('T')[0],
        end_day: this.endDay.split('T')[0],
        page: this.currentPage,
        per_page: this.pageSize,
        sort: this.sortParam
      }
      try {
        const res = await this.getAsin(payload)
        this.total = res.data.total
      } catch (e) {
        console.log(e)
      }
    },
    onUpdateCurrentPage (val) {
      this.currentPage = val
      this.getReport()
    },
    onUpdatePaginationPageSize (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getReport()
    },
    onDateChange (date) {
      this.$store.commit('SET_STARTDAY', moment(date.start).format())
      this.$store.commit('SET_ENDDAY',  moment(date.end).format())
      this.currentPage = 1
      this.resetCurrentPageFlag = true
      this.getReport()
    },
    onSortChange (e) {
      const sortModel = e.columnApi.getColumnState().find(s => s.sort != null)
      if (sortModel) {
        const sortParam = `${sortModel.colId}-${sortModel.sort}`
        if (this.sortParam !== sortParam) {
          this.currentPage = 1
        }
        this.sortParam = sortParam
        this.getReport()
      }
    },
    async onCSVExportClick () {
      const payload = {
        start_day: this.startDay.split('T')[0],
        end_day: this.endDay.split('T')[0],
        sort: this.sortParam,
        action: 'asin'
      }
      try {
        await this.downloadCSV(payload)
      } catch (e) {
        console.log(e)
      }
    }
  }
}

</script>

<style>
.holamundo .vs-popup {
  width: 700px;
}
</style>
